export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6610.0a2cf355.jpg";